const video = [
    {
        path: '/video/:id',
        name: 'video',
        component: () => import('@/view/video/Index')
    },
]
export default video